import { Data_getInstance2dx6odfkdwlsm as Data_getInstance } from './adapter/SaveBoostMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SaveBoostMutation_VariablesAdapter_instance2lm8atx218dgg as SaveBoostMutation_VariablesAdapter_instance } from './adapter/SaveBoostMutation_VariablesAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(saveBoost) {
        this.v6h_1 = saveBoost;
      }
      toString() {
        return 'Data(saveBoost=' + this.v6h_1 + ')';
      }
      hashCode() {
        return this.v6h_1 == null ? 0 : getBooleanHashCode(this.v6h_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.v6h_1 == other.v6h_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.w6h_1 = 'e36c069a6c3b1da025fd6b7d830edb88152eea68e636017c5acbf2e2fee0270e';
        this.x6h_1 = 'saveBoost';
      }
      h6g() {
        return 'mutation saveBoost($input: SaveBoostInput!) { saveBoost(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var SaveBoostMutationClass;
function SaveBoostMutation() {
  if (SaveBoostMutationClass === VOID) {
    class $ {
      constructor(input) {
        this.y6h_1 = input;
      }
      j6g() {
        return 'e36c069a6c3b1da025fd6b7d830edb88152eea68e636017c5acbf2e2fee0270e';
      }
      operationId() {
        return this.j6g();
      }
      x48() {
        return Companion_instance.h6g();
      }
      k6g() {
        return 'saveBoost';
      }
      operationName() {
        return this.k6g();
      }
      r47(writer, customScalarAdapters, withDefaultValues) {
        SaveBoostMutation_VariablesAdapter_instance.z6h(writer, this, customScalarAdapters, withDefaultValues);
      }
      q47() {
        return obj(Data_getInstance());
      }
      toString() {
        return 'SaveBoostMutation(input=' + this.y6h_1.toString() + ')';
      }
      hashCode() {
        return this.y6h_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SaveBoostMutation()))
          return false;
        if (!this.y6h_1.equals(other.y6h_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SaveBoostMutation', VOID, VOID, [Mutation()]);
    SaveBoostMutationClass = $;
  }
  return SaveBoostMutationClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Data as Data20ir384tdyz1e,
  SaveBoostMutation as SaveBoostMutation360x4uh5hti27,
};
//endregion

//# sourceMappingURL=SaveBoostMutation.mjs.map
